import { Tag } from 'antd'

import { RecipeStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status: RecipeStatus
}

const ColorMap = {
  [RecipeStatus.DECLINED]: 'error',
  [RecipeStatus.NEW]: 'warning',
  [RecipeStatus.CANCELLED]: 'error',
  [RecipeStatus.DISPENSED]: 'success'
}

export const PrescriptionsStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  return <Tag color={ColorMap[status]}>{t(`recipes.status.${status}`)}</Tag>
}
